(ns app.front.view.profile.oidc
  (:require [app.front.ui :as ui]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))


(rf/reg-event-db ::init
  (fn [db _]
    (assoc db ::data {})))


(rf/reg-sub ::state
  (fn [db _]
    (get-in db [::data ::state])))


(rf/reg-event-fx ::reset-password
  (fn [{:keys [db]} [_ email]]
    {:db           (assoc-in db [::data ::state] :loading)
     :comm/command {:command    :user/send-reset-password-link
                    :data       {:user/email email}
                    :on-success [::reset-password.success]}}))


(rf/reg-event-db ::reset-password.success
  (fn [db _]
    (assoc-in db [::data ::state] :done)))


(defn current-oidc-provider [tr oidc-name email]
  (let [state (or (<sub [::state]) :init)]
    [:div
     [:div
      (str (tr [:profile/change-password-sso] [oidc-name]) " " (tr [:profile/disconnect-sso-guide] [oidc-name]))]
     [:div
      (case state
        :init
        (cc/button {:kind     :tertiary
                    :on-click #(>evt [::reset-password email])}
                   (tr [:profile/disconnect-sso-button]))

        :loading
        (cc/inline-loading {:description (tr [:profile/resetting])})

        :done
        [:div.font-semibold (tr [:forgot-password/verification] [email])])]]))


(defn connect-oidc-provider [tr {:oidc-config/keys [id display-name]}]
  (r/with-let [*form-ref (r/atom nil)]
    [:div
     [:h4.mb-4 (tr [:profile/sso-heading])]
     [:form {:ref    #(reset! *form-ref %)
             :method "post"
             :action (str "/api/oidc/" id "/set-oidc-provider")}
      [:input {:type "hidden" :name :oidc-config/id :value id}]]
     [ui/modal-confirmation-button {:tr                  tr
                                    :modal-title         (tr [:profile/connect-to-sso] [display-name])
                                    :trigger-button-text (tr [:profile/connect-to-sso] [display-name])
                                    :trigger-button-opts {:size :small
                                                          :kind :tertiary}
                                    :on-yes-click        (fn [_]
                                                           (when-let [form @*form-ref]
                                                             (.submit form)))}
      (tr [:profile/connect-to-sso-modal] [display-name])]]))
